




























import {Component, Vue} from 'vue-property-decorator';
import {LayoutModule} from '@/store/modules/LayoutModule';

@Component({})
export default class PNotification extends Vue {
  get notification() {
    return LayoutModule.notification;
  }

  close() {
    LayoutModule.hideNotification();
  }
}
